// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724069115719/%E7%8E%B0%E5%9C%BA%E4%BD%9C%E4%B8%9A.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724069104251/%E7%8E%B0%E5%9C%BA%E4%BD%9C%E4%B8%9A%20(1).jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724660993589/v4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724660992478/d4.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725154456853/euPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725154630746/euH4.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725161235322/ukPC4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725161234975/ukH4.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    nl: imgAllA.EU,
};
export default imgLocale1;
